<template>
  <div class="factory">
    <Head></Head>
    <factoryPc
      v-if="!isPhone"
      v-show="tab === 'passat'"
      ref="factoryPc"
      @changeTab="changeTab"
    ></factoryPc>
    <factoryPc2
      v-if="!isPhone"
      v-show="tab === 'passatp'"
      ref="factoryPc2"
      @changeTab="changeTab"
    ></factoryPc2>
    <factoryMobile
      v-if="isPhone"
      v-show="tab === 'passat'"
      ref="factoryMobile"
      @changeTab="changeTabMobile"
    ></factoryMobile>
    <factoryMobile2
      v-if="isPhone"
      v-show="tab === 'passatp'"
      ref="factoryMobile2"
      @changeTab="changeTabMobile"
    ></factoryMobile2>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "@/components/header-index.vue";
import Foot from "@/components/footer-index.vue";
import factoryPc from "./idPc.vue";
import factoryPc2 from "../passatp/idPc.vue";
import factoryMobile from "./idMobile.vue";
import factoryMobile2 from "../passatp/idMobile.vue";
export default {
  name: "factory",
  components: {
    Head,
    Foot,
    factoryPc,
    factoryPc2,
    factoryMobile,
    factoryMobile2,
  },
  data() {
    return {
      isPhone: false,
      tab: "passat",
    };
  },
  created() {
    // 判断是否手机
    this.getIsPhone();
    // 设置标题
    this.setTitle();
  },
  methods: {
    changeTab(val) {
      console.log(val);
      this.tab = val;
      this.$refs.factoryPc.clickC();
      this.$refs.factoryPc2.clickC();
    },
    changeTabMobile(val) {
      console.log(val);
      this.tab = val;
      this.$refs.factoryMobile.clickC();
      this.$refs.factoryMobile2.clickC();
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "上汽大众媒体中心";
    },
  },
};
</script>

<style>
</style>


